import PropTypes from 'prop-types';
import Modal from '../../../Modal';

const ClassDetailsModal = ({ priceClassDescriptions, groupedFlights, onClose }) => (
  <Modal open onClose={onClose} className="flex items-center justify-center">
    <div className="p-6 sm:p-8">
      <h4 className="text-lg font-semibold mb-4">Fare Class Details:</h4>

      {groupedFlights && Object.keys(groupedFlights).length > 0 ? (
        Object.values(groupedFlights).map((group) => (
          <div
            key={`${group.fareBrandName}-${group.flights.map((f) => f.originAirportCode).join(',')}`}
          >
            <div className="font-semibold my-2">
              {group.fareBrandName} (
              {group.flights
                .map((flight) => `${flight.originAirportCode} - ${flight.destinationAirportCode}`)
                .join(', ')}
              )
            </div>
            <ul className="text-sm list-disc pl-5 space-y-1">
              {group.priceClassDescriptions.map((description, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={i} className="whitespace-normal break-words">
                  {description}
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <ul className="text-sm list-disc pl-5 space-y-1">
          {priceClassDescriptions.map((description, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index} className="whitespace-normal break-words">
              {description}
            </li>
          ))}
        </ul>
      )}
    </div>
  </Modal>
);

ClassDetailsModal.propTypes = {
  priceClassDescriptions: PropTypes.arrayOf(PropTypes.string),
  groupedFlights: PropTypes.objectOf(
    PropTypes.shape({
      fareBrandName: PropTypes.string,
      priceClassDescriptions: PropTypes.arrayOf(PropTypes.string),
      flights: PropTypes.arrayOf(PropTypes.shape()),
    }),
  ),
  onClose: PropTypes.func.isRequired,
};

ClassDetailsModal.defaultProps = {
  priceClassDescriptions: [],
  groupedFlights: undefined,
};

export default ClassDetailsModal;
